import * as React from 'react';
import ReactEcharts from 'echarts-for-react';
import { useSetDataZoomInterval } from 'helpers/chart/dataZoom';
import { ChartSettingsT } from 'business/definitions';
import { TwoDimGraphProps, SeriePointT } from '../types';
import { useSetLegendDimension } from './hooks/legendDimension';
import {
    getDatasetPoint,
    getDatasetValueKey,
} from '../../helpers/datasetHelpers';
import { LineChartOption } from './ChartOption/LineChartOption';

const Line = ({
    settings,
    data,
    height,
    width,
    orderedColumns,
    isPdfModeActivated,
    isPngModeActivated,
    onClick,
    isChartViewedOnDashboard,
}: TwoDimGraphProps): React.ReactElement => {
    const xColumn = orderedColumns.x;
    const yColumn = orderedColumns.y;
    const zColumn = orderedColumns.z;

    const [dataZoomInterval, setDataZoomInterval] = React.useState<
        ChartSettingsT['dataZoomInterval']
    >(settings?.dataZoomInterval);

    const setDataZoomIntervalListener = useSetDataZoomInterval(
        dataZoomInterval,
        setDataZoomInterval,
    );

    const chartOpt = new LineChartOption(
        orderedColumns,
        settings,
        data,
        width,
        height,
        dataZoomInterval,
        isPdfModeActivated,
        isPngModeActivated,
        !!isChartViewedOnDashboard,
    );

    const onChartClick = React.useCallback(
        (params: SeriePointT) => {
            const xValue = params.value[getDatasetValueKey(params)];
            if (xValue) {
                const point = getDatasetPoint(params, orderedColumns);
                onClick(point, xColumn.key);
            }
        },
        [onClick, JSON.stringify(orderedColumns)],
    );

    const option = chartOpt.getChartOption();
    useSetLegendDimension(
        yColumn,
        zColumn,
        // @ts-expect-error [type] doesn't expect the echart type but ours.
        option.series,
        chartOpt.treeValueTranslations,
    );

    return (
        <ReactEcharts
            option={option}
            notMerge
            onEvents={{
                click: onChartClick,
                dataZoom: setDataZoomIntervalListener,
            }}
            style={{ height, width }}
            className="line-chart"
            opts={{ renderer: 'canvas' }}
        />
    );
};
export default Line;
